

import { Component, Inject } from '@angular/core';

@Component({
    selector: 'advanced-management',
    template: require('./advancedManagement.html'),
    styles: [require('./_advancedManagement.scss')]
})
export class AdvancedManagementComponent {

    public item = {name:'domainManager', appLink :'app.authorized.usersRolesManagement.advancedManagement.domainManager'}

    constructor(@Inject('$state') private $state: any) {
        this.$state.go('app.authorized.usersRolesManagement.advancedManagement.domainManager', 'domainManager');
    }

    public navigate(event: any, item: any) {
        if (!item.appLink) {
            return;
        }
        event.preventDefault();
        this.item = item
        this.$state.go(item.appLink, item.name);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/advancedManagement-ang7.ts